import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { BaseIcon } from '../../../components/base-icon.mjs';

const SvgPersonChalkboard = forwardRef((props, ref) => /* @__PURE__ */ jsxs(BaseIcon, { fill: "currentColor", ref, ...props, children: [
  /* @__PURE__ */ jsx("path", { d: "M16 10a1 1 0 0 0-1-1h-3v2h3a1 1 0 0 0 1-1" }),
  /* @__PURE__ */ jsx("path", { d: "M13 15v-2h2a3 3 0 1 0 0-6h-2.256c.166-.47.256-.974.256-1.5 0-.515-.086-1.01-.245-1.47Q12.872 4 13 4h7a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-2.5l1.923 4.615a1 1 0 0 1-1.846.77L15.75 16l-1.827 4.385a1 1 0 0 1-1.089.601q.164-.465.166-.986v-2.6l1-2.4zM6 5.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0" }),
  /* @__PURE__ */ jsx("path", { d: "M15 11h-4v9a1 1 0 1 1-2 0v-4H8v4a1 1 0 1 1-2 0v-6.697l-1.168 1.752a1 1 0 0 1-1.664-1.11L6.16 9.457A1 1 0 0 1 7.017 9H15a1 1 0 1 1 0 2" })
] }));

export { SvgPersonChalkboard as default };
//# sourceMappingURL=person-chalkboard.mjs.map
